// determines the position of the button on screen, not the position of the dropdown
export enum LangSwitchPosition {
  top = 'top',
  bottom = 'bottom',
}
